import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import { formatMoney } from '../components/utilities';

const ReactiveSearch = {
  timeoutId: null,
  searchContainer: document.querySelector('[data-search-result]'),
  searchBackground: document.querySelector('.reactive-search-background'),

  handleAutocomplete: function (_term) {
    const { handlePopulate } = ReactiveSearch;

    clearTimeout(ReactiveSearch.timeoutId);
    ReactiveSearch.timeoutId = setTimeout(async () => {
      if (_term == '') return;

      const headers = new Headers();
      headers.append('Content-type', 'application/json');
      headers.append('accept', 'application/json');
      headers.append('cache', 'no-store');
      // headers.append('cache-control', 'no-cache');

      const requestInit = { headers: headers };
      const response = await fetch(`/busca?q=${_term}&v=${Math.random()}`, requestInit);

      handlePopulate(await response.json(), _term);
    }, 500); // Tempo de espera após a última digitação
  },

  handlePopulate: async function (response, _term) {
    const { searchContainer, searchBackground, reactiveProductsCarousel } = ReactiveSearch;

    // Definindo o atraso para 1 segundo (1000 milissegundos)
    await new Promise((resolve) => setTimeout(resolve, 250));

    let searchResult = '';
    const productsContainer = document.querySelector('[data-list-products]');
    const searchTerm = document.querySelector('[data-search-term]');

    if (!productsContainer) return;

    if (response.length > 0 || _term == '') {
      response.forEach((product) => {
        let priceHTML;
        let imagesHTML = '';
        const images = product.images;
        console.log(product);

        if (images.length > 0) {
          for (let index = 0; index < 2; index++) {
            if (images[index]) {
              imagesHTML += `<img src= "${images[index].url
                .replace('cdn.vnda.com.br/', 'cdn.vnda.com.br/420x/')
                .replace('cdn.vnda.dev/', 'cdn.vnda.dev/420x/')}"></img>`;
            }
          }
        }

        if (product.price === product.sale_price) {
          priceHTML = `<p class="price">${formatMoney(product.price)}</p>`;
        } else {
          priceHTML = `
              <div class="price discount">
                <p class="full"> ${formatMoney(product.price)}</p>
                <p class="discount">${formatMoney(product.sale_price)}</p>
              </div>
          `;
        }

        searchResult += `
            <div class="product-item swiper-slide">
                <a class="image -square" href='${product.url}' aria-label="Acessar produto ${product.name}">
                  ${imagesHTML != '' ? `${imagesHTML}` : "<div class='skeleton'></div>"}        
                </a>
                <div class="text">
                    <div class="name">${product.name}</div>
                    ${priceHTML}
                </div>
            </div>
        `;
      });

      searchResult += `
          <div class="see-all swiper-slide">
            <button type="submit" form="search-form">
              VER TUDO
            </button>
          </div>
      `;

      productsContainer.innerHTML = searchResult;
      if (searchTerm) searchTerm.innerHTML = `BUSCA POR: "${_term}"`;
      searchContainer && searchContainer.classList.add('-active');
      searchBackground && searchBackground.classList.add('-active');

      reactiveProductsCarousel();
    } else {
      productsContainer.innerHTML = '';
      if (searchTerm) searchTerm.innerText = '';
      searchContainer && searchContainer.classList.remove('-active');
      searchBackground && searchBackground.classList.remove('-active');
    }
  },

  reactiveProductsCarousel: function () {
    const container = document.querySelector('[data-search-result]');

    if (container) {
      const swiper = container.querySelector('.swiper');
      const next = swiper.querySelector('.swiper-button-next');
      const prev = swiper.querySelector('.swiper-button-prev');

      const carousel = new Swiper(swiper, {
        modules: [Navigation, Pagination],
        slidesPerView: 2,
        spaceBetween: 8,
        watchOverflow: true,
        speed: 1000,
        observeParents: true,
        observer: true,
        breakpoints: {
          480: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
      });
    }
  },

  init: function () {
    const { searchContainer, searchBackground, handleAutocomplete, reactiveProductsCarousel } = ReactiveSearch;

    const searchInput = document.querySelector('.search-form input');

    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        const value = e.currentTarget.value;

        if (value != '') {
          handleAutocomplete(value);
        } else {
          setTimeout(() => {
            searchContainer && searchContainer.classList.remove('-active');
            searchBackground && searchBackground.classList.remove('-active');
          }, 250);
        }
      });

      reactiveProductsCarousel();
    }
  },
};

export default ReactiveSearch;
